import {info} from "services-comun/modules/browser/log";

import { Auth } from "../../../services/auth";
import { IConfig } from "../../../config";
import { Ruta, IRuta } from "../../ruta";

export class RedaccionRedactores extends Ruta {
    /* STATIC */
    public static build(config: IConfig, id: number): RedaccionRedactores {
        return new this({
            id,
            ruta: `${config.router.basePath}/redaccion/redactores/`,
        });
    }

    /* INSTANCE */
    public constructor(data: IRuta) {
        super(data);
    }

    public async check(path: string): Promise<void> {
        if (path!=this.data.ruta) {
            return Promise.reject("Redaccion/Redactores: Rechazada");
        }
    }

    public async load(auth: Auth, config: IConfig, state?: any): Promise<void> {

        require('panel-templates/css/general.scss')
        info("Cargando NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.load(auth, config, state);
        info("Cargando Redaccion/Redactores");
        const {RedaccionRedactores} = await import(/* webpackChunkName: "redaccion-redactores" */ `../../../componentes/redaccion/redactores/redactores`);
        await RedaccionRedactores.load(auth, config, state);
    }

    public async unload(): Promise<void> {
        // info("Descargando NavBar");
        // const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        // await NavBar.unload();
        info("Descargando Redaccion/Redactores");
        const {RedaccionRedactores} = await import(/* webpackChunkName: "redaccion-redactores" */ `../../../componentes/redaccion/redactores/redactores`);
        await RedaccionRedactores.unload();
    }

    public async updateEstado(state?: any): Promise<void> {
        info("Actualizando el estado de NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.updateEstado(state);
        info("Actualizando el estado de Redaccion/Redactores");
        const {RedaccionRedactores} = await import(/* webpackChunkName: "redaccion-redactores" */ `../../../componentes/redaccion/redactores/redactores`);
        await RedaccionRedactores.updateEstado(state);
    }
}
